/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import Modal from "../components/Modal";
import Nav from "../components/Nav";

const ListItem = ({ number, children }) => {
  return (
    <div className="flex justify-start items-start">
      <div className="w-24 h-24 flex justify-center items-center mr-12 bg-primary-5 rounded-full text-center text-primary-1 text-10 font-bold leading-[16px] tracking-[0.05px]">
        {number}
      </div>
      <div className="flex-1 text-gray-2 text-15 leading-[24px] tracking-[0.023px]">
        {children}
      </div>
    </div>
  );
};
function GuideModal() {
  return (
    <Modal>
      <Nav type="modal" title="이용 안내" />
      <div className="pt-56">
        <div className="px-24 py-40 max-w-[468px] mx-auto">
          <h1 className="mb-24">
            <img
              src="/assets/images/logo.svg"
              alt="무의 로고"
              className="h-20 mx-auto"
            />
          </h1>
          <p className="text-gray-2 text-15 leading-[24px] tracking-[0.023px] mb-24">
            <b>무의 수도권 지하철 교통약자 환승지도</b>는 휠체어 이용자, 임산부,
            유아차 이용자, 일시적 보행 약자, 노약자, 짐을 운반하는 사람 등
            다양한  이동약자의 편의를 위해 제작되었습니다.
            <br />
            <br />
            본 서비스의 환승 정보는 사단법인 무의에서 수집한 정보를 바탕으로
            제공되며 2024년 티머니복지재단의 지원으로 제작되었습니다.
            <br />
            <br />
            현재 서울 지역 환승역 위주로 제공되고 있으며 추후 타 지역으로 확대
            예정입니다.
          </p>
          <div className="mb-40">
            <a target="_blank" href="https://muui.or.kr" rel="noreferrer">
              <button
                type="button"
                className="mx-auto block max-w-[200px] w-full bg-primary-1 text-white rounded-12 text-center py-8 px-10 text-12 font-bold leading-[16px] tracking-[0.06px]"
              >
                무의 홈페이지
              </button>
            </a>
          </div>
          <div className="py-24 px-16 bg-primary-6 rounded-16 mb-40">
            <h3 className="text-gray-1 text-15 font-semibold leading-[24px] tracking-[0.023px] mb-16">
              이용 방법
            </h3>
            <div className="gap-16 grid">
              <ListItem number={1}>
                지도를 참고하여 출발역을 검색하고 이용할 호선에 맞춰 선택합니다.
              </ListItem>
              <ListItem number={2}>
                도착역을 검색하고 이용할 호선에 맞춰 선택합니다.
              </ListItem>
              <ListItem number={3}>
                검색 결과에서 전체 이동 역 개수, 환승역, 환승역에서의 경로 등을
                확인할 수 있습니다.
              </ListItem>
            </div>
            <div className="bg-gray-8 h-1 w-full my-16" />
            <div className="text-gray-2 text-12 leading-[20px] tracking-[0.03px] mb-16">
              ※ 검색 결과 오류가 생기는 경우
              <br />- 무의에서 환승 경로 조회에 사용하는 공공API의 오류
              <br />- 환승 경로 정보 미수집 경로 정보 미수집
              <br />
              <br />※ 철도 노선의 신설 및 폐선, 역사의 신설 및 시설 변경 등에
              따라 최신 정보가 반영되지 않을 수 있습니다. 이용 중 불편한 점,
              오류 제보, 이용 후기, 궁금한 점 등은 아래 버튼을 클릭하여
              보내주시기 바랍니다.
            </div>
            <div className="">
              <a
                href="https://forms.gle/WsJ7PdSEiC6d4X9Y8"
                alt=""
                target="_blank"
                rel="noreferrer"
              >
                <button
                  type="button"
                  className="py-7 px-10 rounded-12 w-full border-1 border-gray-8 bg-white text-center text-primary-1 text-12 font-bold leading-[16px] tracking-[0.06px]"
                >
                  제보하기
                </button>
              </a>
            </div>
          </div>
          <div className="">
            <img
              src="/assets/images/logo-tmoney.svg"
              alt="티머니 복지재단 로고"
              className="mx-auto h-20"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default GuideModal;
